<div class="app-center-crop-thumbnail img" [ngStyle]="imgStyles()" #img></div>